// Mock data for GOLDHAT Portfolio

export const personalInfo = {
  name: "LALITH SAGAR",
  alias: "GOLDHAT",
  role: "DevOps . AI Systems . Red Team Simulations . Digital Warfare Architect",
  github: "https://github.com/lalithsagarJ",
  linkedin: "https://www.linkedin.com/in/lalithsagarj/",
  location: "India (Zone AS-501)",
  clearance: "LETHAL INTELLIGENCE CLASS-4",
  avatarPlaceholder: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=400&fit=crop"
};

export const bio = [
  "Built dozens of cloud infrastructures across AWS, GCP, and Azure ecosystems",
  "Designed multi-cluster GKE + Istio service meshes for high-traffic fintech platforms",
  "Created AI-powered agent frameworks: ShadowMind, OpsMind, WarMind",
  "Expert in Terraform, Kubernetes, Cloud Networking, and Red Team Labs",
  "Architect of offensive research terminals and autonomous AI systems"
];

export const skills = {
  devops: [
    { name: "Jenkins / GitHub Actions", level: 95 },
    { name: "Terraform (Architect)", level: 92 },
    { name: "Kubernetes", level: 85 },
    { name: "Cloud Networking", level: 90 },
    { name: "Docker / Containerization", level: 93 },
    { name: "Prometheus / Grafana", level: 85 }
  ],
  security: [
    { name: "Red Team Labs", level: 87 },
    { name: "Adversary Simulation", level: 84 },
    { name: "OSINT Automation", level: 82 },
    { name: "Security Hardening", level: 88 },
    { name: "Threat Modeling", level: 85 }
  ],
  ai: [
    { name: "LLM Orchestration", level: 90 },
    { name: "Local AI Terminals", level: 88 },
    { name: "Payload Generation Labs", level: 83 },
    { name: "Autonomous Agents", level: 91 },
    { name: "AI System Architecture", level: 89 }
  ]
};

export const projects = [
  {
    id: 1,
    name: "ShadowMind Terminal",
    status: "Active",
    role: "Local AI Offensive Research Terminal",
    description: "Advanced AI-powered terminal for security research and adversarial simulation. Features multi-agent orchestration, command & control simulation engine, and autonomous payload generation capabilities.",
    technologies: ["Python", "LLMs", "C2 Simulation", "Multi-Agent Systems"],
    classification: "RESTRICTED",
    year: "2024-Present"
  },
  {
    id: 2,
    name: "OpsMind",
    status: "Active",
    role: "AI DevOps Assistant",
    description: "Intelligent DevOps automation framework leveraging AI for infrastructure management, deployment orchestration, and incident response. Reduces operational overhead by 70% through predictive analytics.",
    technologies: ["Python", "Kubernetes", "Terraform", "AI/ML"],
    classification: "PRODUCTION",
    year: "2023-Present"
  },
  {
    id: 3,
    name: "WarMind Recon",
    status: "Active",
    role: "AI Bug Bounty Engine",
    description: "Autonomous vulnerability discovery system combining AI-driven reconnaissance with intelligent exploit chain generation. Identified 50+ critical vulnerabilities across various platforms.",
    technologies: ["Python", "AI", "Security Tools", "Automation"],
    classification: "CLASSIFIED",
    year: "2024-Present"
  },
  {
    id: 4,
    name: "OneIndia Azure Migration",
    status: "Completed",
    role: "Migration Lead",
    description: "Orchestrated on-premise to Azure cloud migration for media platform. Designed hybrid architecture, implemented disaster recovery, and optimized for high-availability streaming services.",
    technologies: ["Azure", "Hybrid Cloud", "Disaster Recovery", "DevOps"],
    classification: "PRODUCTION",
    year: "2025"
  },
  {
    id: 5,
    name: "Delhi University Cloud Migration",
    status: "Completed",
    role: "Cloud Migration Architect",
    description: "Led enterprise-scale migration from AWS to GCP for educational institution. Migrated 200+ services, implemented auto-scaling infrastructure, achieved 99.9% uptime with 40% cost reduction.",
    technologies: ["GCP", "Terraform", "Kubernetes", "Cloud Migration"],
    classification: "PRODUCTION",
    year: "2025"
  },
  {
    id: 6,
    name: "LeadSquared Infrastructure",
    status: "Completed",
    role: "Infrastructure Architect",
    description: "Designed and implemented multi-region GCP infrastructure for SaaS platform. Built auto-scaling GKE clusters, Istio service mesh, and ClickHouse logging platform handling 1M+ events/day.",
    technologies: ["GCP", "GKE", "Istio", "ClickHouse", "Terraform"],
    classification: "PRODUCTION",
    year: "2025"
  },
  {
    id: 7,
    name: "Tonns to Automations",
    status: "Completed",
    role: "Devops Engineer",
    description: "Developed multi scenario system automations using jenkins pipelines, gitlab ci and github actions. ",
    technologies: ["Jenkins", "Shell Scripting", "Monitoring", "Devops", "GCP/Azure Deployments"],
    classification: "PRODUCTION",
    year: "2023-2025"
  },
  {
    id: 8,
    name: "ClickHouse Logging Platform",
    status: "Completed",
    role: "Devops Engineer",
    description: "Built high-performance logging infrastructure for fintech applications. Achieved sub-second query times on billions of log records, implemented real-time analytics and alerting.",
    technologies: ["ClickHouse", "Kafka", "Kubernetes", "Grafana"],
    classification: "PRODUCTION",
    year: "2025"
  }
];

export const timeline = [
  {
    year: "2025",
    title: "Seasoned Devops & AI Systems Architect",
    description: "Leading Cloud Infrastructure and development of autonomous AI agent frameworks and digital warfare simulation systems",
    status: "current"
  },
  {
    year: "2024-2025",
    title: "Cloud Migration Expert",
    description: "Verse Innovations - Leading enterprise-scale cloud migration projects across multiple platforms (Media, Education, SaaS)",
    status: "completed"
  },
  {
    year: "2024",
    title: "Creator of ShadowMind & Architect of OpsMind",
    description: "Developed AI-powered DevOps assistant reducing operational overhead by 70%. Built local AI offensive research terminal with multi-agent orchestration capabilities",
    status: "completed"
  },
  {
    year: "2023",
    title: "Devops Engineer",
    description: "Verse Innovation - Designed and maintained enterprise-scale cloud infrastructure across multiple platforms",
    status: "completed"
  },
  {
    year: "2022",
    title: "Associate DevOps Engineer",
    description: "Verse Innovation - Learnt and Built automated deployment pipelines and infrastructure as code solutions for Dailyhunt",
    status: "completed"
  }
];

export const easterEggs = {
  goldhat: {
    trigger: "goldhat",
    message: ">> GOLDHAT PROTOCOL ACTIVATED",
    effect: "matrix-rain"
  },
  opsmind: {
    trigger: "opsmind",
    message: ">> OPSMIND SYSTEMS ONLINE",
    effect: "ai-hologram"
  },
  shadowmind: {
    trigger: "shadowmind",
    message: ">> SHADOWMIND ENGAGED - STEALTH MODE",
    effect: "red-glitch"
  },
  whoami: {
    trigger: "whoami",
    message: `>> IDENTITY: GOLDHAT\n>> ROLE: Digital Warfare Architect\n>> STATUS: ONLINE\n>> CLEARANCE: CLASS-4`,
    effect: "terminal-popup"
  }
};